// components/common/ExportButtons.js
import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ExportButtons = ({ data, filename = "RTS_Report", elementId }) => {
    const today = new Date().toISOString().split("T")[0];

    const downloadCSV = () => {
        const headers = ["Date", "Job No", "Order No", "Total Pieces", "Sizes", "Remark"];
        const csvRows = [headers.join(",")];

        data.forEach(row => {
            const sizes = Object.entries(row.size_variant_quantity || {})
                .map(([k, v]) => `${k}:${v}`)
                .join(" ");
            const values = [
                row.date,
                row.job_no,
                row.cut_order_no,
                row.total_piece,
                `"${sizes}"`,
                row.remark || "-"
            ];
            csvRows.push(values.join(","));
        });

        const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}_${today}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePrint = () => {
        const printContents = document.getElementById(elementId)?.innerHTML;
        if (printContents) {
            const win = window.open('', '_blank');
            win.document.write(`
        <html>
          <head>
            <title>Print - ${filename}</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 30px;
                color: #000;
              }
  
              h2, h3 {
                margin-top: 20px;
                margin-bottom: 10px;
                color: #222;
              }
  
              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 20px;
              }
  
              th, td {
                border: 1px solid #ccc;
                padding: 8px 10px;
                text-align: left;
                font-size: 12px;
              }
  
              th {
                background-color: #f0f0f0;
              }
  
              .section-header {
                background-color: #e0e7ff;
                padding: 10px;
                margin-top: 30px;
                border-radius: 6px;
                font-weight: bold;
                font-size: 16px;
              }
  
              .color-title {
                margin: 10px 0;
                font-weight: bold;
                font-size: 14px;
              }
  
              .summary {
                margin-bottom: 15px;
                font-size: 13px;
              }
            </style>
          </head>
          <body>${printContents}</body>
        </html>
      `);
            win.document.close();
            win.focus();
            win.print();
        }
    };

    const downloadPDF = () => {
        const element = document.getElementById(elementId);
        if (!element) return;

        // Clone and wrap with more padding
        const clone = element.cloneNode(true);
        const wrapper = document.createElement("div");

        // Add larger padding and white background for clarity
        wrapper.style.padding = "40px";
        wrapper.style.background = "white";
        wrapper.style.width = "fit-content"; // ensure content width fits
        wrapper.appendChild(clone);

        document.body.appendChild(wrapper); // temporarily add to DOM

        html2canvas(wrapper, { scale: 2 }).then(canvas => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "pt", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const imgHeight = (canvas.height * pageWidth) / canvas.width;

            pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
            pdf.save(`${filename}_${today}.pdf`);

            document.body.removeChild(wrapper); // clean up
        });
    };


    return (
        <div className="flex flex-wrap gap-3 mb-4">
            <button
                onClick={handlePrint}
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-lg shadow transition-all duration-200 flex items-center gap-2"
            >
                🖨️ <span>Print</span>
            </button>
            <button
                onClick={downloadPDF}
                className="bg-rose-500 hover:bg-rose-600 text-white font-semibold px-4 py-2 rounded-lg shadow transition-all duration-200 flex items-center gap-2"
            >
                📄 <span>PDF</span>
            </button>
            <button
                onClick={downloadCSV}
                className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-4 py-2 rounded-lg shadow transition-all duration-200 flex items-center gap-2"
            >
                📥 <span>CSV</span>
            </button>
        </div>
    );
};

export default ExportButtons;
